import type { useOtpInput } from '@/hooks/use-otp-input';
import { Input } from '@mokoboko/components';
import { mergeClassNames } from '@/lib/utils';

interface OtpInputGroupProps {
  otp: ReturnType<typeof useOtpInput>;
  hasError?: boolean;
  errorMessage?: string;
}

const OtpInputGroup = ({ otp, hasError, errorMessage }: OtpInputGroupProps) => (
  <div className="flex flex-col">
    <div
      className={mergeClassNames(
        'flex items-center gap-2',
        hasError && 'animate-shake'
      )}
    >
      {otp.values.map((digit, index) => (
        <Input
          key={index}
          ref={(el) => {
            otp.inputRefs.current[index] = el;
          }}
          type="text"
          inputMode="numeric"
          autoComplete="one-time-code"
          maxLength={1}
          value={digit}
          onChange={(e) => otp.handleChange(index, e.target.value)}
          onFocus={() => otp.handleFocus(index)}
          onKeyDown={(e) => otp.handleKeyDown(index, e)}
          onPaste={index === 0 ? otp.handlePaste : undefined}
          hasError={hasError}
          className="!rounded-lg !px-0 !text-center !text-lg !font-semibold"
          aria-label={`Digit ${index + 1}`}
        />
      ))}
    </div>
    {hasError && errorMessage && (
      <p className="mt-2 text-center text-sm leading-5 text-error-500">
        {errorMessage}
      </p>
    )}
  </div>
);

export default OtpInputGroup;
